import type {IntentDetectionMode} from '../types/intent-detection-mode'

export function intentDetectionHeaders(intentDetectionMode?: IntentDetectionMode): Record<string, string> {
  // We only send ask or task, otherwise default to detecting
  const additionalHeaders: Record<string, string> = {}
  if (intentDetectionMode === 'ask') {
    additionalHeaders['X-Copilot-Pinned-Intent'] = 'sync_llm'
  } else if (intentDetectionMode === 'task') {
    additionalHeaders['X-Copilot-Pinned-Intent'] = 'async_agent'
  } else if (intentDetectionMode === 'auto') {
    additionalHeaders['X-Copilot-Pinned-Intent'] = 'auto'
  }

  return additionalHeaders
}
